import UpdateAccount from './UpdateAccount';
import RightSidebarUpdAccount from './RightSidebarUpdAccount';

import ColumnsContent from '../../../../../components/Hocs/ColumnsContent';

export default ColumnsContent(UpdateAccount, RightSidebarUpdAccount);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/UpdateAccount/index.js